
import * as Scroll from './utils/scroll.js';

//* error placement =================================================== */

function validateErrorPlacement(error, element, where) {
  where = typeof where !== 'undefined' ? where : 'under';
  if (where == 'under') {
    if (element.is(':checkbox')||element.is(':radio')||element.is(':file')) {
      error.insertAfter(element.closest(".form-control"));
    } else {
      error.insertAfter(element);
    }
  } else if (where == 'label') {
    if (element.is(':checkbox')||element.is(':radio')||element.is(':file')) {
      error.appendTo(element.parent().parent('div').children('label:first-child'));
    } else {
      error.appendTo(element.parent('div').children('label'));
    }
  }
};


//* freeform setup & validation =================================================== */

$(document).ready(function(){
  if ($('.form-freeform').length) {

    // convert to html5 fieldtypes
    $('[name="phone"],[name="mobile"]').attr('type','tel');
    $('[name="email"]').attr('type','email').attr('autocapitalize','off').attr('autocorrect','off');
    $('[name="address"]').attr('autocorrect','off');
    $('[name="name"]').attr('autocorrect','off');
    $('[name="postcode"]').attr('type','number');

    // validate default
    $('.form-freeform').validate({
      ignore: ".ignore",
      onfocusout: function (element) {
        $(element).attr('data-edit', 1).valid();
      },
      onkeyup: function(element) {
        if ($(element).attr('data-edit') == '1') {
          $(element).valid();
        }
      },
      validClass: 'has-success',
      errorElement: 'p',
      errorClass: 'has-error',
      errorPlacement: function(error,element) {
        validateErrorPlacement(error,element,'under'); // 'under' or 'label'
      },
      rules: {
      },
    });

    $('.form-freeform').find('input').each(function() {
      if ($(this).attr('type') == 'email') {
        $(this).rules('add', {
          email: true,
          messages: {
            email: 'Please enter a valid email address'
          }
        });
      } else if ($(this).attr('type') == 'tel') {
        $(this).rules('add', {
          regex: /^(\(?(\+61|[0-9]) ?[0-9]\)?)? ?[0-9]{2} ?[0-9]{2} ?[0-9]{1} ?[0-9]{3}$/,
          messages: {
            regex: 'Please enter a valid phone number'
          }
        });
      } else if ($(this).attr('name') == 'Postcode') {
        $(this).rules('add', {
          regex: /^[0-9]+$/,
          messages: {
            regex: 'Please enter a valid postcode'
          }
        });
      } else if ($(this).attr('type') == 'file') {
        $(this).rules('add', {
          extension: 'pdf|doc|docx|gif|png|jpg|jpeg',
          filesize: 5242880,
          messages: {
            extension: 'Please select a valid file type',
            filesize: 'File must be less than 5MB'
          }
        });
      }
    });

    $('.form-freeform .l_required').find('input, select, textarea').each(function() {
      if ($(this).attr('type') == 'email') {
        $(this).rules('add', {
          required: true,
          email: true,
          messages: {
            // required: 'This is a required field',
            email: 'Please enter a valid email address'
          }
        });
      } else {
        $(this).rules('add', {
          required: true,
          messages: {
            // required: 'This is a required field'
          }
        });
      }
    });

    $('.form-freeform [type="hidden"]').each(function() {
      if ($(this).hasClass('hiddenRecaptcha')) {
      // console.log('testing');
        $(this).rules('add', {
          required: true
        });
      }
    });

  }
});


//* form ajax submit =================================================== */

$(document).on('submit','form[data-ajax]',function(e){

  e.preventDefault();

  // init
  var $thisForm = $(this);
  var thisUrl = $thisForm.attr('action');
  var thisFormId = $thisForm.attr('id');
  var thisFormActualId = $thisForm.attr('data-id');
  var autoRedirect = '';
  var success_msg = $thisForm.attr('data-msg');
  if (typeof success_msg == 'undefined' || success_msg.length == 0) {
    success_msg = '<h2>Form submitted</h2><p>Thanks for getting in touch.</p>';
  }
  var isSuperWomen = document.querySelector('.form-response').classList.contains('form-response--superwomen');

  // custom
  if (thisFormId == 'form_enquiryItrackCanaloplastyWhitepaper') {
    autoRedirect = '/viscodilation/';
  }

  // generate form data
  var form_data = new FormData(document.getElementById(thisFormId));
  form_data.append($(this).attr('name'), $(this).val());

  // validate form and go
  $thisForm.validate();
  if ($thisForm.valid()) {

    // set form status to loading
    Scroll.toElement(document.querySelector('.form-freeform'));
    $thisForm.find('input, select, textarea').attr('disabled', 'disabled');
    $thisForm.addClass('s_loading');
    $thisForm.find('.form-errors').remove();

    $.ajax({
      url: thisUrl,
      type: "post",
      data: form_data,
      cache: false,
      contentType: false,
      processData: false,
      error: function (response, textStatus, errorThrown) {

        console.log(response);
        console.log(textStatus);
        console.log(errorThrown);

        // remove loading status
        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.removeClass('s_loading');

        // include error
        $('.form-freeform').prepend('<div class="form-errors"><p><strong>Sorry, there was an error submitting your form. Please try again, or call if issues persist.</strong></p><p>Message: ' + errorThrown + '</p></div>');

        // scroll to top
        setTimeout(function () {
          Scroll.toElement(document.querySelector('.form-group.has-error'));
        }, 10);

      },
      success: function (response, textStatus, jqXHR) {

        $thisForm.find('input, select, textarea').removeAttr('disabled');
        $thisForm.removeClass('s_loading');

        if (response.success && response.finished) {

          $thisForm.remove();
          
          if (isSuperWomen) {
            // Prepend message rather than replacing content
            var formResponseMain = document.querySelector('.form-response-main');
            formResponseMain.innerHTML = success_msg + formResponseMain.innerHTML;

            // Add response to social links
            var yourSuperpower = encodeURIComponent("My superpower: " + form_data.get('message'));
            
            // Get links
            var twitterShareLink = document.querySelector('.js-share-twitter');
            var emailShareLink = document.querySelector('.js-share-email');

            if (twitterShareLink) {
              var twitterHref = twitterShareLink.href;
              var twitterRegex = /(.*\?text=)(.*)/gi;
              var newTwitterHref = twitterHref.replace(twitterRegex, "$1" + yourSuperpower + "%0D%0A$2");
              twitterShareLink.href = newTwitterHref;
            }
            
            if (emailShareLink) {
              var emailHref = emailShareLink.href;
              var emailRegex = /(.*body=)(.*)/gi;
              var newEmailHref = emailHref.replace(emailRegex, "$1" + yourSuperpower + "%0D%0A$2");
              emailShareLink.href = newEmailHref;
            }
          }
          else {
            $('.form-response-main').html(success_msg);
          }
          $('.form-response').addClass('s_active');

          // auto redirect
          if (autoRedirect) {
            window.location.href = autoRedirect;
          }

        } else if (response.errors || response.formErrors) {

          // loop through field specific errors
          for (var key in response.errors) {
            if (!response.errors.hasOwnProperty(key)) continue;
            var messages = response.errors[key];
            var $errors  = $("<p>", {"class": "has-error"});
            for (var i = 0; i < messages.length; i++) {
              var $li = $("<span>");
              $li.html(messages[i]);
              $errors.append($li);
            }

            var $input = $("*[name=" + key + "], *[name='" + key + "[]']");

            var $formGroup = $input.parents(".form-group");
            $formGroup.addClass("has-error");

            $formGroup.append($errors);
          }

          // loop through form errors
          var formErrors = '';
          for (var key in response.formErrors) {
            if (!response.formErrors.hasOwnProperty(key)) continue;
            formErrors += '<p>' + response.formErrors[key] + '</p>';
          }

          // display errors
          $('.form-freeform').prepend('<div class="form-errors"><p><strong>Sorry, there was an error submitting your form.</strong></p>' + formErrors + '</div>');

          // scroll to top
          setTimeout(function(){
            if ($('.form-group.has-error').length) {
              Scroll.toElement(document.querySelector('.form-group.has-error'));
            } else {
              Scroll.toElement(document.querySelector('.form-errors'));
            }
          }, 10);

        }

      }
    });
  }

  return false;
});



//* placeholder form fields =================================================== */

function placeholderInit() {
  $('.form-group.l_placeholder').each(function(){
    if ($(this).find('input, select, textarea').val() !== '') {
      // $(this).addClass('s_active');
    }

    // $(this).find('select').each(function(){
    //   $(this).find('option').each(function(){
    //     console.log($(this).val());
    //     if ($(this).val() == 'Please select...') {
    //       $(this).attr('val', '');
    //       $(this).attr('text', '');
    //     }
    //   });
    // });
  });
}

$(document).ready(function(){
  placeholderInit();
});


//* forms =================================================== */

$(document).on('focus','.form-group input, .form-group select, .form-group textarea',function(){
  var $this = $(this);
  $this.parents('.form-group').addClass('s_focus');
});

$(document).on('blur','.form-group input, .form-group select, .form-group textarea',function(){
  var $this = $(this);
  $this.parents('.form-group').removeClass('s_focus');
});

$(document).on('focus blur change','.form-group input, .form-group select, .form-group textarea',function(){
  var $this = $(this);
  if ($this.val() != '') {
    $this.parents('.form-group').addClass('s_active');
  } else {
    $this.parents('.form-group').removeClass('s_active');
  }
});


//* auto expand textareas =================================================== */
// Applied globally on all textareas with the "l_auto-expand" class
$(document)
.on('focus.l_auto-expand', 'textarea.l_auto-expand', function(){
    var savedValue = this.value;
    this.value = '';
    this.baseScrollHeight = this.scrollHeight;
    this.value = savedValue;
})
.on('input.l_auto-expand', 'textarea.l_auto-expand', function(){
    var minRows = this.getAttribute('data-min-rows')|0, rows;
    this.rows = minRows;
    rows = Math.ceil((this.scrollHeight - this.baseScrollHeight) / 20);
    this.rows = minRows + rows;
});



//* file upload fields =================================================== */

function inputFileInit($item) {

  // init
  $input = $item;
  $label = $input.next( 'label' );
  label_val = $label.html();

  // on change input
  $input.on('change', function(e) {

    // get filename(s)
    var fileName = '';
    if (this.files && this.files.length > 1) {
      fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
    } else if( e.target.value ) {
      fileName = e.target.value.split( '\\' ).pop();
    }

    // set filename on label
    if (fileName) {
      $label.html( fileName );
    } else {
      $label.html( labelVal );
    }

  });

  // firefox bug fix
  $input.on('focus', function() {
    $input.addClass('s_focus');
  });
  $input.on('blur', function() {
    $input.removeClass('s_focus');
  });

}

function inputFileInitAll() {
  $('.file-upload').each(function() {
    inputFileInit($(this));
  });
}

$(document).ready(function(){
  inputFileInitAll();
});


// country field

var countryCurrent = '';
$(document).on('change focus blur','[name="country"]',function(){
  var $this = $(this);
  if ($this.val() == 'Australia' && $this.val() !== countryCurrent) {
    countryCurrent = $this.val();
    $('label[for="form-input-state"]').text('State');
    $('[name="state"]').replaceWith('<select name="state" id="form-input-state">' +
    '<option value="">Please select...</option>' +
    '<option value="ACT">Australian Capital Territory</option>' +
    '<option value="NSW">New South Wales</option>' +
    '<option value="NT">Northern Territory</option>' +
    '<option value="QLD">Queensland</option>' +
    '<option value="SA">South Australia</option>' +
    '<option value="TAS">Tasmania</option>' +
    '<option value="VIC">Victoria</option>' +
    '<option value="WA">Western Australia</option>' +
    '</select>');
  } else if ($this.val() == 'United States' && $this.val() !== countryCurrent) {
    countryCurrent = $this.val();
    $('label[for="form-input-state"]').text('State');
    $('[name="state"]').replaceWith('<select name="state">' +
    '<option value="">Please select...</option>' +
    '<option value="AL">Alabama</option>' +
    '<option value="AK">Alaska</option>' +
    '<option value="AZ">Arizona</option>' +
    '<option value="AR">Arkansas</option>' +
    '<option value="CA">California</option>' +
    '<option value="CO">Colorado</option>' +
    '<option value="CT">Connecticut</option>' +
    '<option value="DE">Delaware</option>' +
    '<option value="DC">District Of Columbia</option>' +
    '<option value="FL">Florida</option>' +
    '<option value="GA">Georgia</option>' +
    '<option value="HI">Hawaii</option>' +
    '<option value="ID">Idaho</option>' +
    '<option value="IL">Illinois</option>' +
    '<option value="IN">Indiana</option>' +
    '<option value="IA">Iowa</option>' +
    '<option value="KS">Kansas</option>' +
    '<option value="KY">Kentucky</option>' +
    '<option value="LA">Louisiana</option>' +
    '<option value="ME">Maine</option>' +
    '<option value="MD">Maryland</option>' +
    '<option value="MA">Massachusetts</option>' +
    '<option value="MI">Michigan</option>' +
    '<option value="MN">Minnesota</option>' +
    '<option value="MS">Mississippi</option>' +
    '<option value="MO">Missouri</option>' +
    '<option value="MT">Montana</option>' +
    '<option value="NE">Nebraska</option>' +
    '<option value="NV">Nevada</option>' +
    '<option value="NH">New Hampshire</option>' +
    '<option value="NJ">New Jersey</option>' +
    '<option value="NM">New Mexico</option>' +
    '<option value="NY">New York</option>' +
    '<option value="NC">North Carolina</option>' +
    '<option value="ND">North Dakota</option>' +
    '<option value="OH">Ohio</option>' +
    '<option value="OK">Oklahoma</option>' +
    '<option value="OR">Oregon</option>' +
    '<option value="PA">Pennsylvania</option>' +
    '<option value="RI">Rhode Island</option>' +
    '<option value="SC">South Carolina</option>' +
    '<option value="SD">South Dakota</option>' +
    '<option value="TN">Tennessee</option>' +
    '<option value="TX">Texas</option>' +
    '<option value="UT">Utah</option>' +
    '<option value="VT">Vermont</option>' +
    '<option value="VA">Virginia</option>' +
    '<option value="WA">Washington</option>' +
    '<option value="WV">West Virginia</option>' +
    '<option value="WI">Wisconsin</option>' +
    '<option value="WY">Wyoming</option>' +
    '</select>');
  } else if ($this.val() != countryCurrent) {
    countryCurrent = $this.val();
    $('label[for="form-input-state"]').text('City / State');
    $('[name="state"]').replaceWith('<input name="state" type="text" id="form-input-state">');
  }
});


//* auto prefill =================================================== */

$(document).ready(function() {
  if (window.location.href.indexOf('investors') > -1) {
    $('[name="subscriberGroup"][value="Investor"]').click();
  }
});